import { Modal } from "react-bootstrap";
import { useFilterContext } from "../../../hooks/FilterContext";
import ThemedModal from "../../../components/utilities/ThemedModal";
import { useEffect, useState } from "react";
import _ from "lodash";
import { Button } from "../../../components";
import { DateInput, FormSelect, RangeInput } from "../../../components/forms";
import { GenericUserSelect } from "../../../components/forms/selects";

const HubwiseJobsFilterModal = ({ show, onHide }) => {

    const { defaultFilters, filter, setFilter } = useFilterContext();
    const [tempFilter, setTempFilter] = useState(filter);

    const onApplyFilters = () => {
        setFilter(orig => ({
            ...orig,
            ...tempFilter
        }));
        onHide();
    }

    const onClearFilters = () => {
        setTempFilter(defaultFilters);
    }

    const onFilterValueChanged = (property, value) => {
        setTempFilter((original) => {
            return {
                ...original,
                [property]: value,
            };
        });
    };

    const onClose = () => {
        setTempFilter(filter);
        onHide();
    };

    useEffect(() => {
        setTempFilter(oldTemp =>
            !_.isEqual(oldTemp, filter)
                ? filter
                : oldTemp
        );
    }, [filter]);

    const {
        organisationIds,
        startedByIds,
        runDateFrom,
        runDateTo,
        statuses
    } = tempFilter;

    return <Modal size="lg" centered backdrop="static" show={show} onHide={onHide}>
        <ThemedModal.Header>
            <Modal.Title>Hubwise Job Filters</Modal.Title>
        </ThemedModal.Header>
        <Modal.Body>
            <div className="row gy-2">
                <div className="col-6">
                    <FormSelect
                        label="Organisation(s)"
                        defaultValue={organisationIds}
                        options={[{ label: "Save & Invest", value: '67c9544b-cd44-47a7-9c9a-42c4fc9d90f1' }]}
                        onChange={(selections) => onFilterValueChanged('organisationIds', selections.map(s => s.value))}
                        disableAnimations
                        isMulti
                    />
                </div>
                <div className="col-6">
                    <GenericUserSelect
                        label="Job Started By"
                        defaultValue={startedByIds}
                        onChange={(selections) => onFilterValueChanged('startedByIds', selections.map(s => s.value))}
                        disableAnimations
                        isMulti
                    />
                </div>
                <div className="col-6">
                    <FormSelect
                        label="Status"
                        defaultValue={statuses}
                        options={[
                            { value: 0, label: "Running" },
                            { value: 1, label: "Succeeded" },
                            { value: 2, label: "Succeeded with Warning(s)" },
                            { value: 3, label: "Failed" }
                        ]}
                        onBlur={(selections) => onFilterValueChanged('statuses', selections.map(s => s.value))}
                        disableAnimations
                        isMulti
                    />
                </div>
                <div className="col-6">
                    <RangeInput
                        InputComponent={DateInput}
                        label="Run Date"
                        startProps={{
                            value: runDateFrom,
                            onBlur: (date) => onFilterValueChanged('runDateFrom', date),
                            maxDate: runDateTo == null ? new Date() : Date.parse(runDateTo)
                        }}
                        endProps={{
                            value: runDateTo,
                            onBlur: (date) => onFilterValueChanged('runDateTo', date),
                            minDate: runDateFrom == null ? null : Date.parse(runDateFrom)
                        }}
                        disableAnimations
                        isClearable
                    />
                </div>
            </div>
        </Modal.Body>
        <Modal.Footer>
            <Button variant="warning" onClick={onClearFilters}>
                Clear Filters
            </Button>
            <Button variant="success" onClick={onApplyFilters}>
                Apply Filters
            </Button>
            <Button variant="light" onClick={onClose}>
                Cancel
            </Button>
        </Modal.Footer>
    </Modal>
}

export default HubwiseJobsFilterModal;